// src/store/services/flowApi.js
import { createApi, fetchBaseQuery, } from "@reduxjs/toolkit/query/react";
import { secureBaseQuery } from "./secureBaseQuery";
import {api} from "../../Appjs/api.js";

export const flowApi = createApi({
  reducerPath: "flowApi",
  baseQuery: fetchBaseQuery({
    baseUrl: api,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("accessToken");
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
      //  baseQuery: secureBaseQuery,

  endpoints: (builder) => ({
    saveFlow: builder.mutation({
      query: (payload) => ({
        url: "/flow/save",
        method: "POST",
        body: payload,
      }),
    }),

getFlows: builder.query({
  query: ({ page = 1, search = "" }) => ({
    url: "/flow/list",
    params: { page, search },
  }),
}),

    getFlowById: builder.query({
      query: (cf_id) => `/flow/${cf_id}`,
    }),

    updateFlow: builder.mutation({
      query: ({ cf_id, ...payload }) => ({
        url: `/flow/${cf_id}`,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["Workflows"],
    }),

    runWorkflowSms: builder.mutation({
      query: (formData) => ({
        url: "/flow/run-sms",
        method: "POST",
        body: formData,
      }),
    }),

    // 🟢 Customer services
    getCustomerServices: builder.query({
      query: (customerId) =>
        `/flow/get-customer-service/${customerId}`,
    }),

    // 🟢 Flow order report
    flowOrderReport: builder.query({
      query: ({ startDate, endDate, page = 1, limit = 10 }) => ({
        url: "/flow/campaigns/order-summary",
        params: {
          startDate,
          endDate,
          page,
          limit,
        },
      }),
    }),

    // 🟢 SMS order report
    smsOrderReport: builder.query({
      query: ({ campaignflow_id }) => ({
        url: `/flow/campaigns/status-count`,
        params: { campaignflow_id },
      }),
    }),

    // 🟢 SMS flow report counts
    smsflowreportcounts: builder.query({
      query: ({ campaignflow_id, status,page,limit }) => ({
        url: `/flow/campaigns/status-details?campaignflow_id=${campaignflow_id}&status=${status}&page=${page}&limit=${limit}`,
      }),
    }),
   // 🟢 Manage DB access check
    dataEnableService: builder.query({
      query: () => "/flow/data-enabled/manage-db",
    }),
     getscheduleflowreport: builder.query({
      query: ({ startDate, endDate, page = 1, limit = 10 }) => ({
        url: `/flow/campaigns/scheduled-order-summary?startDate=${startDate}&endDate=${endDate}&page=${page}&limit=${limit}`,
      }),
    }),
  }),
});

export const {
  useFlowOrderReportQuery,
  useLazyFlowOrderReportQuery,
  useSaveFlowMutation,
  useGetFlowsQuery,
  useGetFlowByIdQuery,
  useUpdateFlowMutation,
  useRunWorkflowSmsMutation,
  useGetCustomerServicesQuery,
  useSmsOrderReportQuery,
  useSmsflowreportcountsQuery,
  useLazySmsflowreportcountsQuery,
  useDataEnableServiceQuery,
  useLazyGetscheduleflowreportQuery,
} = flowApi;